import React from 'react';
import AutomationRulesPage from '../AutomationRulesPage';
import AdminLayout from '../../components/layout/AdminLayout';

const AdminAutomationPage = () => (
  <AutomationRulesPage LayoutComponent={AdminLayout} clientsEndpoint="/clients" />
);

export default AdminAutomationPage;
